import { splitTextByLinks } from './helpers/splitTextByLinks'
import { LinkifiedLink } from './LinkifiedLink'

type TLinkifiedTextProps = {
    text: string
}

/**
 * Renders text with http(s) URLs as anchors. Gate calls on whoever wrote the text being trusted; plain
 * text is the default.
 */
export const LinkifiedText = ({ text }: TLinkifiedTextProps) => (
    <>
        {splitTextByLinks(text).map(part =>
            part.url ? (
                <LinkifiedLink key={part.start} href={part.url}>
                    {part.text}
                </LinkifiedLink>
            ) : (
                part.text
            ),
        )}
    </>
)
